/**
 * 是否是参数类型
 *
 * @param {Object} value 测试的值
 * @return {Boolean}
 */
import isType from './is-type';
var isError = function (value) {
    return isType(value, 'Error');
};
export default isError;
//# sourceMappingURL=is-error.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/is-error.js
// module id = 491
// module chunks = 3